import { Add, Subtract } from '@carbon/icons-react';
import * as React from 'react';

import { cn } from 'DesignSystem/utils';

type Props = {
  insideLabel?: string | React.ReactNode;
  name: string;
  defaultValue?: number;
  disabled?: boolean;
  onChange: (c: number, name: string) => void;
  classNames?: string;
  hideSteppers?: boolean;
};

export default function NumberInput({
  insideLabel,
  name,
  defaultValue,
  disabled,
  onChange,
  classNames,
  hideSteppers = false,
}: Props) {
  const [count, setCount] = React.useState(defaultValue ?? 0);

  // hate this but need to reset the count when 'cancel' is clicked in the parent component
  React.useEffect(() => {
    setCount(defaultValue ?? 0);
  }, [defaultValue]);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
    const c = Number(e.target.value);
    if (isNaN(c)) return;
    setCount(c);
    onChange(c, name);
  }
  function handleAddition(): void {
    const newCount = count + 1;
    setCount(newCount);
    onChange(newCount, name);
  }
  function hanldeSubtraction(): void {
    const newCount = count > 0 ? count - 1 : count;
    setCount(newCount);
    onChange(newCount, name);
  }

  return (
    <div
      className={cn(
        'flex w-full items-center rounded-lg border border-zinc-200 bg-white py-2 pl-3 pr-2 text-sm font-medium',
        classNames
      )}
    >
      <div className={cn('flex flex-1 justify-center', disabled || hideSteppers ? 'ml-0' : 'ml-3')}>
        {insideLabel && <span className="text-zinc-500">{insideLabel}</span>}
        <input
          className="text-center disabled:bg-white disabled:text-zinc-500"
          name={name}
          value={count}
          disabled={disabled}
          onChange={handleChange}
          size={2}
        />
      </div>
      <div className={cn('rounded-sm shadow', disabled || hideSteppers ? 'hidden' : '')}>
        <div className="cursor-pointer select-none border-b border-zinc-200 hover:bg-zinc-100" onClick={handleAddition}>
          <Add className="h-4 w-4 text-indigo-700" />
        </div>
        <div className="cursor-pointer select-none hover:bg-zinc-100" onClick={hanldeSubtraction}>
          <Subtract className="h-4 w-4 text-indigo-700" />
        </div>
      </div>
    </div>
  );
}
